// extracted by mini-css-extract-plugin
export default {"panel":"create_panel__QuFFh","content":"create_content__S2KHf"};